export const updateProviderTracks = (data) => ({
  type: 'UPDATE_PROVIDER_TRACKS',
  data,
});
